var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "32px",
    height: "32px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.8,12.8) scale(0.9,0.9)"
  }, /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0,
    fill: "#000000",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-14.22222,270.22222v-284.44444h284.44444v284.44444z",
    id: "bgRectangle"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#735741",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128,270.22222c-78.54716,0 -142.22222,-63.67506 -142.22222,-142.22222v0c0,-78.54716 63.67506,-142.22222 142.22222,-142.22222v0c78.54716,0 142.22222,63.67506 142.22222,142.22222v0c0,78.54716 -63.67506,142.22222 -142.22222,142.22222z",
    id: "shape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(3.55556,3.55556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5,14c-14.375,0 -15.5,1.125 -15.5,15.5v13c0,14.375 1.125,15.5 15.5,15.5h13c14.375,0 15.5,-1.125 15.5,-15.5v-13c0,-14.375 -1.125,-15.5 -15.5,-15.5zM26,22h20c3.71,0 4,0.29 4,4v20c0,3.71 -0.29,4 -4,4h-20c-3.71,0 -4,-0.29 -4,-4v-20c0,-3.71 0.29,-4 4,-4zM36.58984,24.97266v14.99414c0,2.061 -1.79212,3.12695 -3.07812,3.12695c-0.969,0 -3.17383,-0.76134 -3.17383,-3.15234c0,-2.509 2.05727,-3.14844 3.19727,-3.14844c0.664,0 0.92383,0.14063 0.92383,0.14063v-4c0,0 -0.49741,-0.07422 -1.06641,-0.07422c-4.082,0 -6.98828,3.30498 -6.98828,7.08398c0,3.193 2.49855,7.05859 7.06055,7.05859c4.859,0 7.08203,-4.05216 7.08203,-7.03516v-7.4375c0,0 2.16536,1.51563 5.06836,1.51563v-3.78906c-3.33,-0.237 -5.11037,-2.4752 -5.23437,-5.2832z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok-icon.fcd489f14d87faae6af999e81cd50882.svg";
export { ForwardRef as ReactComponent };